// src/components/Footer.jsx
import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import { SiTiktok } from "react-icons/si";

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300 mt-20">

      {/* Main footer content */}
      <div className="container mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-8 py-10">

        {/* PTfinderNow Info */}
        <div>
          <h3 className="text-2xl font-bold text-white mb-4">PTfinderNow v1.0</h3>
          <p className="text-sm">
            Our first stable public release.
            Built for real experts, real clients, and long-term growth. More features coming soon.
          </p>
        </div>

        {/* Navigation Links */}
        <div>
          <h4 className="text-xl font-semibold mb-4 text-white">Navigation</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-blue-400">🏠 Home</Link></li>
            <li><Link to="/About" className="hover:text-blue-400">ℹ️ About</Link></li>
            <li><Link to="/Contact" className="hover:text-blue-400">📞 Contact Us</Link></li>
            <li><Link to="/TermsAndConditions" className="hover:text-blue-400">📜 Terms & Conditions</Link></li>
            <li><Link to="/PrivacyPolicy" className="hover:text-blue-400">🔒 Privacy Policy</Link></li>
          </ul>
        </div>

        {/* Social Media */}
        <div>
          <h4 className="text-xl font-semibold mb-4 text-white">Follow Us</h4>
          <div className="flex space-x-4 text-2xl">
            <a href="https://www.facebook.com/profile.php?id=61576582881580" target="_blank" rel="noreferrer" className="hover:text-blue-500"><FaFacebookF /></a>
            <a href="https://instagram.com/ptfindernow/" target="_blank" rel="noreferrer" className="hover:text-pink-400"><FaInstagram /></a>
            <a href="https://twitter.com/ptfindernow/" target="_blank" rel="noreferrer" className="hover:text-sky-400"><FaTwitter /></a>
            <a href="https://www.linkedin.com/in/ptfinder-now-229b0a367/" target="_blank" rel="noreferrer" className="hover:text-sky-400"><FaLinkedinIn /></a>
            <a href="https://www.youtube.com/@ptfindernow" target="_blank" rel="noreferrer" className="hover:text-blue-300"><FaYoutube /></a>
            <a href="https://www.tiktok.com/@ptfindernow" target="_blank" rel="noreferrer" className="hover:text-blue-300"><SiTiktok /></a>
          </div>
        </div>
      </div>

      <div className="text-center text-gray-500 text-sm pb-6">
        © {new Date().getFullYear()} PTfinderNow. All rights reserved.
      </div>
    </footer>
  );
}
